import {Container} from '../../components/Container';
import React, {memo} from 'react';
import {ScenarioPage} from '../../components/ScenarioPage';
import {backButtonToggle, groupSettingAction, scenarioSettingAction} from "../../store/ui/actions";
import {useDispatch} from "react-redux";

export const ScenarioScreen = memo(function ScenarioScreen() {
    const dispatch = useDispatch();
    dispatch(backButtonToggle({is_open: true, to: '/'}));
    dispatch(groupSettingAction({visible: false}));
    dispatch(scenarioSettingAction({visible: true}));
    return (
        <Container>
            <div className="page-wrapper">
                <ScenarioPage/>
            </div>
        </Container>
    );
});
